module.exports = __webpack_public_path__ + "static/media/martell_power.84f9e24f.png";